import { 
    setUserInfo, 
    getUserInfo, 
    clearUserInfo, 
    getToken, 
    setToken, 
} from "#/storage/auth";

//
import {
    ifWechat,
    ifZiubaoAndroidWebView,
    ifZiubaoIosWebView,
    ifYszsAndroidWebView,
    ifYszsIosWebView,
} from "#/utils/platform.js"

//
import {
    getShopTopDomainUrl,
} from '#/utils/common.js'

//
import axios from "#/net/axios"

/**
 * vuex
 */
const state = {
    userInfo: getUserInfo(),
    token: getToken(),
}

const getters = {
    
}

const mutations = {
    setUserInfo(state, data) {
        state.userInfo = data;

        //
        setUserInfo(data);
    },

    clearUserInfo(state)
    {
        state.userInfo = null;

        //
        clearUserInfo();
    },

    setToken(state, data)
    {

        //
        state.token = data;

        //
        setToken(data);
    },
}

const actions = {
    getUserInfo({ commit })
    {
        axios.shop.get("/user/getCuser.do").then(({statusCode, msg, data}) => {
            if (statusCode == '200')
            {
                //
                if (data.mobile == null)
                {
                    data.mobile = data.userName;
                }

                //
                commit("setUserInfo", data);
                
                if (window.WeChatTongDaPay && window.WeChatTongDaPay.getJiGuangResiterId && window.WeChatTongDaPay.mobileLoginSuccess)
                {
                    const registerId = window.WeChatTongDaPay.getJiGuangResiterId();
                    window.WeChatTongDaPay.mobileLoginSuccess(data.mobile);

                    //
                    let platform;
                    if(ifZiubaoAndroidWebView())
                    {
                        platform = "ziubao"
                    }
                    else if(ifYszsAndroidWebView())
                    {
                        platform = "yszs"
                    }
                    if(registerId && registerId.length > 0)
                    {
                        axios.shop.post("jiguangpush/setAlias.do", {
                            appType: platform,
                            deviceType: "android",
                            registerId,
                            mobile: data.mobile,
                        })
                    }
                }
                if(window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.JPushInitUser && window.webkit.messageHandlers.JPushGetRegisterId)
                {       
                    if (!window.iosGtzn)
                    {
                        window.iosGtzn = {

                        }
                    };
                    window.iosGtzn.JPushInitUserCb = error => {
                        if(error)
                        {
                            console.error(`JPushInitUser fail, ${error.toString()}`);
                        }
                    }
                    window.iosGtzn.JPushGetRegisterIdCb = (error, registerId) => {
                        if (error)
                        {
                            return console.error(`JPushGetRegisterIdCb failed, ${error.toString()}`)
                        }

                        (async () => {
                            //
                            let platform;
                            if(await ifZiubaoIosWebView())
                            {
                                platform = "ziubao"
                            }
                            else if(await ifYszsIosWebView())
                            {
                                platform = "yszs"
                            }

                            //
                            axios.shop.post("jiguangpush/setAlias.do", {
                                appType: platform,
                                deviceType: "ios",
                                registerId,
                                mobile: data.mobile,
                            })
                        })().catch( e => {
                            console.error(`upload jpush info fail, ${e.toString()}`)
                        });
                    }

                    //
                    window.webkit.messageHandlers.JPushInitUser.postMessage({
                        mobile: data.mobile,
                    });
                    window.webkit.messageHandlers.JPushGetRegisterId.postMessage({});
                }

                // wechat auth
                if (ifWechat() && data.openid != 'fail' && (data.openid == null || data.openid == ''))
                {
                    //
                    const wechatAuthUrl = `${getShopTopDomainUrl()}WxAuth/wxLogin.do?redirectUrl=${window.location.href}`;
                    
                    //
                    document.location.replace(wechatAuthUrl);
                }
            }
        });
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
